import { CopyToClipboardButtonProps } from '../../types/components/shared/CopyToClipboardButton';
import { useState, useEffect } from 'react';
import { ShareIcon, CheckmarkIcon } from '../../modules/Icons';

import { RESET_COPY_TO_CLIPBOARD_BUTTON_UI_INTERVAL } from '../../constants/ui';

export const defaultButtonTextBeforeCopy = 'Copy';
export const defaultButtonTextAfterCopy = 'Copied!';

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = (props: CopyToClipboardButtonProps) => {
  const {
    contentToCopy,
    className,
    buttonTextBeforeCopy = defaultButtonTextBeforeCopy,
    buttonTextAfterCopy = defaultButtonTextAfterCopy,
  } = props;

  const [displayCopiedContentUI, setDisplayCopiedContentUI] = useState<boolean>(false);
  let timer: ReturnType<typeof setTimeout>;

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [])

  const onCopyContent = async () => {
    await navigator.clipboard.writeText(contentToCopy);
    setDisplayCopiedContentUI(true);
    timer = setTimeout(() => setDisplayCopiedContentUI(false), RESET_COPY_TO_CLIPBOARD_BUTTON_UI_INTERVAL * 1000);
  }

  return (
    <button
      onClick={onCopyContent}
      className={className}
      cy-test-id="copy-to-clipboard-button"
    >
      {displayCopiedContentUI ? <CheckmarkIcon/> : <ShareIcon />} { displayCopiedContentUI ? buttonTextAfterCopy : buttonTextBeforeCopy }
    </button>
  )
}

export default CopyToClipboardButton;
